// noinspection ES6CheckImport

import { parse, isValid, format } from 'date-fns';

export function isEmptyObject(obj) {
    return !obj || Object.keys(obj).length === 0;
}

export function getCfgOffer(cfgOffers, offerName) {
    return cfgOffers.find((cfgOffer) => (cfgOffer.offer_name === offerName));
}

export function parseDate(date, format) {
    let parsed = parse(date, format, new Date());
    return (isValid(parsed)) ? parsed : null;
}

export function parseTime(time) {
    return new Date(`1970-01-01T${time}`);
}

export function formatDate(date, fmt = 'dd.MM.yy') {
    try {
        return format(date, fmt);
    } catch (error) {
        return '';
    }
}

export function formatTime(datetime, fmt = 'HH:mm') {
    try {
        return format(datetime, fmt);
    } catch (error) {
        return '';
    }
}

export function formatDateTime(datetime, fmt='dd.MM.yy HH:mm') {
    try {
        return format(datetime, fmt);
    } catch (error) {
        return '';
    }
}

export function formatPrice(price) {
    return (price)
        ? new Intl.NumberFormat('ru-RU', {
            style: 'currency', currency: 'RUB', minimumFractionDigits: 0, maximumFractionDigits: 2
        }).format(price)
        : '';
}

export function getUserType(userType) {
    switch (userType) {
        case 1:
            return 'Администратор';
        case 2:
            return 'Партнер';
        case 3:
            return 'Клиент';
        default:
            return 'Неизвестный тип';
    }
}

export function getInternalStatus(internal) {
    switch (internal) {
        case -1:
            return 'Отказ';
        case 0:
            return 'В процессе';
        case 1:
            return 'Принято';
        default:
            return 'В процессе';
    }
}

export function humanizeConversion(conversion) {
    return conversion.toFixed(2).toString().replace(/\.?0*$/,'') + '%';
}

export function humanizeNumber(number) {
    // noinspection JSCheckFunctionSignatures
    return number.toLocaleString('ru-RU');
}

//https://stackoverflow.com/questions/16245767/creating-a-blob-from-a-base64-string-in-javascript?rq=1
export function base64toBlob (b64Data, sliceSize = 512) {
    const byteArrays = [];
    const byteCharacters = atob(b64Data);

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);

        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        byteArrays.push(new Uint8Array(byteNumbers));
    }
  return new Blob(byteArrays);
}
